import { render, staticRenderFns } from "./WidgetChart3.vue?vue&type=template&id=99fbd5e6&scoped=true"
import script from "./WidgetChart3.vue?vue&type=script&lang=js"
export * from "./WidgetChart3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fbd5e6",
  null
  
)

export default component.exports